export default __webpack_public_path__ + "static/media/supplier-4.af43d274.png";